var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":'/' + _vm.isLink}},[_c('div',{staticClass:"py-8 border rounded-md bg-gray-100 hover:bg-gray-50 text-center w-52 flex"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }